import { useState } from "react";
import API from "../api"; // ✅ correct path

export default function TextInputBox({ text, setText }) {
  return (
    <div className="p-6 bg-white rounded-2xl shadow-md w-full max-w-2xl mx-auto">
      <h2 className="text-xl font-semibold mb-4 text-center">📄 Enter Text</h2>
      <textarea
        className="w-full border rounded-lg p-3 focus:ring focus:ring-blue-200 resize-none"
        rows="8"
        placeholder="Paste your paragraph or notes here..."
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
    </div>
  );
}